// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container for the entire punishment list */
.punishment-list-container {
  width: 75%; /* Adjust width to 75% of the page */
  margin: 0 auto; /* Center the container */
  height: 80%;
  /* padding: 20px; */
  /* background-color: #f5f7fa; */
  /* border-radius: 8px; */
  /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); */
}


.search-bar-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
/* Search bar styling */
.search-bar {
  width: 80%;
  padding: 12px;
  margin-bottom: 20px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

/* Styling the list of punishment cards */
.punishment-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 450px;
  overflow-y: auto; /* Enable vertical scrolling */
}

/* Individual punishment card */
.punishment-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 15px 20px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: background-color 0.2s ease;
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
}

.punishment-card:hover {
  background-color: #f1f3f5;
}

/* Punishment item styling */
.punishment-item {
  flex: 1 1; /* Equal spacing between items */
  text-align: center;
  padding: 0 15px; /* Space between items */
}

.punishment-item:first-child {
  text-align: left; /* Align first item to the left */
}

.punishment-item:last-child {
  text-align: right; /* Align last item to the right */
}

/* Punishment type colors */
.punishment-card.ban {
  background-color: #ff8a7d;
  border-left: 8px solid #e74c3c; 
}

.punishment-card.mute {
  background-color: #ffa9f8; 
  border-left: 8px solid #ff61f2; 
}

.punishment-card.kick {
  background-color: #fffc54; 
  border-left: 8px solid #ebe700;
}

.punishment-card.warn {
  background-color: #64ff5c;
  border-left: 8px solid #0be500;
}

.label {
  font-weight: bold;
  margin-right: 6px;
}

/* Punishment type colors */
/* .punishment-card.ban {
  border-left: 6px solid #e74c3c;
}

.punishment-card.mute {
  border-left: 6px solid #f39c12; 
}

.punishment-card.kick {
  border-left: 6px solid #3498db; 
}

.punishment-card.warn {
  border-left: 6px solid #2ecc71;
} */

/* Pagination controls */
.pagination-controls {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-top: 20px;
}

.pagination-controls button {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  background-color: #3498db;
  color: white;
  cursor: pointer;
  font-size: 14px;
}

.pagination-controls button:hover {
  background-color: #2980b9;
}

.pagination-controls button:disabled {
  background-color: #bdc3c7;
  cursor: not-allowed;
}

.pagination-controls span {
  font-size: 16px;
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/components/PunishmentList.css"],"names":[],"mappings":"AAAA,6CAA6C;AAC7C;EACE,UAAU,EAAE,oCAAoC;EAChD,cAAc,EAAE,yBAAyB;EACzC,WAAW;EACX,mBAAmB;EACnB,+BAA+B;EAC/B,wBAAwB;EACxB,8CAA8C;AAChD;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;AACA,uBAAuB;AACvB;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yCAAyC;AAC3C;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB,EAAE,8BAA8B;AAClD;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;EACxC,sCAAsC;EACtC,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,SAAO,EAAE,gCAAgC;EACzC,kBAAkB;EAClB,eAAe,EAAE,wBAAwB;AAC3C;;AAEA;EACE,gBAAgB,EAAE,iCAAiC;AACrD;;AAEA;EACE,iBAAiB,EAAE,iCAAiC;AACtD;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;;;;;;;;;;;;;;GAcG;;AAEH,wBAAwB;AACxB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB","sourcesContent":["/* Container for the entire punishment list */\n.punishment-list-container {\n  width: 75%; /* Adjust width to 75% of the page */\n  margin: 0 auto; /* Center the container */\n  height: 80%;\n  /* padding: 20px; */\n  /* background-color: #f5f7fa; */\n  /* border-radius: 8px; */\n  /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); */\n}\n\n\n.search-bar-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n/* Search bar styling */\n.search-bar {\n  width: 80%;\n  padding: 12px;\n  margin-bottom: 20px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  font-size: 16px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n/* Styling the list of punishment cards */\n.punishment-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  max-height: 450px;\n  overflow-y: auto; /* Enable vertical scrolling */\n}\n\n/* Individual punishment card */\n.punishment-card {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 15px 20px;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: background-color 0.2s ease;\n  width: 100%;\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n.punishment-card:hover {\n  background-color: #f1f3f5;\n}\n\n/* Punishment item styling */\n.punishment-item {\n  flex: 1; /* Equal spacing between items */\n  text-align: center;\n  padding: 0 15px; /* Space between items */\n}\n\n.punishment-item:first-child {\n  text-align: left; /* Align first item to the left */\n}\n\n.punishment-item:last-child {\n  text-align: right; /* Align last item to the right */\n}\n\n/* Punishment type colors */\n.punishment-card.ban {\n  background-color: #ff8a7d;\n  border-left: 8px solid #e74c3c; \n}\n\n.punishment-card.mute {\n  background-color: #ffa9f8; \n  border-left: 8px solid #ff61f2; \n}\n\n.punishment-card.kick {\n  background-color: #fffc54; \n  border-left: 8px solid #ebe700;\n}\n\n.punishment-card.warn {\n  background-color: #64ff5c;\n  border-left: 8px solid #0be500;\n}\n\n.label {\n  font-weight: bold;\n  margin-right: 6px;\n}\n\n/* Punishment type colors */\n/* .punishment-card.ban {\n  border-left: 6px solid #e74c3c;\n}\n\n.punishment-card.mute {\n  border-left: 6px solid #f39c12; \n}\n\n.punishment-card.kick {\n  border-left: 6px solid #3498db; \n}\n\n.punishment-card.warn {\n  border-left: 6px solid #2ecc71;\n} */\n\n/* Pagination controls */\n.pagination-controls {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.pagination-controls button {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 4px;\n  background-color: #3498db;\n  color: white;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.pagination-controls button:hover {\n  background-color: #2980b9;\n}\n\n.pagination-controls button:disabled {\n  background-color: #bdc3c7;\n  cursor: not-allowed;\n}\n\n.pagination-controls span {\n  font-size: 16px;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
